import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

export const BoxContainerStyle = styled(Box)`
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 16px 10px;
  line-height: 21px;
  margin-bottom: 4px;
  @media (max-width: 414px) {
    flex-direction: column;
  }
`;

export const BoxAvatar = styled(Box)`
  width: 100%;
  max-width: 80px;
  padding-right: 4px;

  @media (max-width: 414px) {
    margin: 0 auto;
  }
`;

export const BoxAvatarImg = styled.img`
  object-fit: contain;
  max-width: 100%;
`;

export const BoxInfo = styled(Box)``;

export const BoxIcon = styled(Box)`
  flex-wrap: wrap;
  grid-gap: 10px;
`;

export const TypographyP = styled(Typography)`
  color: ${(props) => props.theme.colors.ghost};
  min-height: 36px;
  display: flex;
  align-items: center;
  @media (max-width: 414px) {
    font-size: 12px;
  }
`;

export const TypographyPClickable = styled(TypographyP)`
  cursor: pointer;
  text-decoration: underline;
`;
